<template>
  <el-dialog :visible.sync="stopVisibel" :before-close="cancel" :title="stopTitle" width="900px">
    <el-form :model="stopForm" class="dialogBox" size="small">
      <el-row>
        <el-form-item label="原因">
          <el-select v-model="stopForm.reason" placeholder="请选择原因">
            <el-option label="设计如此" value="设计如此"/>
            <el-option label="不做" value="不做"/>
            <el-option label="延期" value="延期"/>
            <el-option label="已细分" value="已细分"/>
            <el-option label="重复" value="重复"/>
          </el-select>
        </el-form-item>
      </el-row>
      <el-form-item label="备注">
        <TipTapEditor v-if="stopVisibel" :height="200" v-model="stopForm.note"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submitStop(12,7)">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import Tinymce from '@/components/Tinymce'
export default {
  name: 'stopDialog',
  props: ['visible', 'typeId','lastTask'],
  components: { Tinymce },
  data() {
    return {
      stopTitle: '',
      stopVisibel: false,
      stopForm: {
        note: null,
        reason: '',
        email: ''
      },
      taskIdList: []
    }
  },
  computed: {
    ...mapGetters(['userId', 'urlInfo'])
  },
  watch: {
    visible(val) {
      this.stopVisibel = val
      this.stopDialog()
    }
  },
  created() {},
  methods: {
    stopDialog() {
      if (this.typeId === 1) {
        this.stopTitle = '废弃'
      } else {
        this.stopTitle = '暂停'
      }
      this.stopForm = {
        note: null,
        reason: '',
        email: ''
      }
    },
    submitStop(form) {
      // console.log(22);
      this.taskIdList = []
      this.taskIdList.push(this.$route.query.task_id)
      const params = {
        user_id: this.userId,
        type: this.typeId,
        reason: this.stopForm.reason,
        note: this.stopForm.note,
        task_id: this.taskIdList
        // system_code: this.urlInfo.systemCode
      } // 废弃

      if(this.lastTask){
        params.is_discard = 1
      }
      // console.log(params);
      this.$emit('submitStop', params)
    },
    cancel() {
      this.$emit('cancel')
      this.stopForm = {
        note: '',
        reason: '',
        email: ''
      }
      this.editVisible = false
    }
  }
}
</script>
<style scope>
</style>
